<template>
  <v-dialog v-model="mostradoDialogoArchivo" persistent scrollable max-width="600px">
    <v-form>
      <v-card>
        <v-card-title class="pt-2 pb-0">Subir Archivo</v-card-title>

        <v-divider class="my-2"></v-divider>

        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12" lg="8" offset-lg="2">
              <div class="d-flex justify-center align-center contenedor-previsualizacion">
                <v-img
                  v-if="previsualizacion && esImagen"
                  :src="previsualizacion"
                  aspect-ratio="1"
                  contain
                  height="300px"></v-img>

                <iframe v-else-if="previsualizacion && esPDF" :src="previsualizacion" height="300px"></iframe>

                <v-icon v-else>mdi-image-broken-variant</v-icon>
              </div>
            </v-col>

            <v-col cols="12">
              <v-file-input
                v-model="archivo"
                class="file-input"
                label="Adjuntar Respaldo JPG, PNG, PDF (Opcional)"
                accept="image/jpeg, image/png, image/jpg, application/pdf"
                :prepend-icon="''"
                prepend-inner-icon="mdi-paperclip"
                outlined
                dense
                clearable
                hide-details
                @change="onFileChange"></v-file-input>

              <small class="d-block text-muted"> Formatos permitidos: JPG, PNG, PDF </small>

              <small v-for="error in errores.archivo" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions>
          <v-btn
            color="blue darken-1"
            type="button"
            :disabled="cargando"
            text
            @click.prevent="
              () => {
                mostradoDialogoArchivo = false;
                errores.archivo = [];
              }
            ">
            Cerrar
          </v-btn>

          <v-btn
            color="blue darken-1"
            type="submit"
            :disabled="cargando"
            :loading="cargando"
            text
            @click="subirArchivoAdjunto">
            Subir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import DetalleSolicitudService from './../services/detalle-solicitud';
import PagoDetalleSolicitudService from './../services/pago-detalle-solicitud';
import previsualizacionMixin from './../mixins/previsualizacion-imagenes.mixin';

export default {
  name: 'ModalArchivoRespaldo',
  mixins: [previsualizacionMixin],
  props: {
    respaldoDe: {
      type: String,
      required: true,
      validator: (value) => ['detalle-solicitud', 'pago-detalle-solicitud'].includes(value),
    },
  },
  data() {
    return {
      cargando: false,
      mostradoDialogoArchivo: false,
      errores: { archivo: [] },
      detalleSeleccionadoId: null,
      detalleSeleccionadoIndice: null,
    };
  },
  watch: {
    archivo() {
      this.errores.archivo = [];
    },
  },
  methods: {
    abrir(detalleId, indice) {
      this.detalleSeleccionadoId = detalleId;
      this.detalleSeleccionadoIndice = indice;
      this.resetearVariablesPrevisualizacion();
      this.mostradoDialogoArchivo = true;
    },
    cerrar() {
      this.mostradoDialogoArchivo = false;
    },
    async subirArchivoAdjunto() {
      this.cargando = true;

      try {
        let response;

        if (this.respaldoDe === 'detalle-solicitud') {
          response = await DetalleSolicitudService.subirArchivoAdjunto(this.detalleSeleccionadoId, {
            archivo: this.archivoBase64,
          });
        } else if (this.respaldoDe === 'pago-detalle-solicitud') {
          response = await PagoDetalleSolicitudService.subirArchivoAdjunto(this.detalleSeleccionadoId, {
            archivo: this.archivoBase64,
          });
        }

        const data = response?.data;
        const datos = data?.datos;

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'Archivo adjunto subido correctamente',
          type: 'success',
        });
        this.$emit('actualizadoArchivoAdjunto', this.detalleSeleccionadoIndice, datos.id);
        this.detalleSeleccionadoId = null;
        this.detalleSeleccionadoIndice = null;
      } catch (error) {
        window.console.log(error);

        const data = error.response?.data;
        const errores = data?.errores;
        const mensaje = data?.mensaje;

        if (typeof errores === 'object') {
          this.errores = errores;
        }

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al subir el archivo adjunto',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.contenedor-previsualizacion {
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  padding: 10px;
  height: 320px;
  max-height: 320px;
  background-color: #f5f5f5;
}

.contenedor-previsualizacion iframe {
  border: none;
}
</style>